<template>
  <td>
    <!-- <button class="k-primary k-button k-grid-edit-command" @click="editHandler">Edit</button>
    <button class="k-button k-grid-remove-command" @click="removeHandler">Remove</button> -->
    <span class="action-icon nt-eye-fill px-1" @click="viewHandler"></span>
    <span class="action-icon nt-edit px-1" @click="editHandler"></span>
    <span class="action-icon nt-trash-fill px-1" @click="removeHandler"></span>
  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    editHandler: function() {
      this.$emit("edit", { dataItem: this.item });
    },
    removeHandler: function() {
      this.$emit("remove", { dataItem: this.item });
    },
    viewHandler: function() {
      this.$emit("view", { dataItem: this.item });
    }
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style>
</style>
